<template>
    <div class="w-100 h-100 d-flex flex-column">
        <table-filter v-if="!noQueryInput" :fields="visibleFields" class="mb-1 qv-filter-panel"
                      :default-form="defaultFilterForm"
                      @change="whenSearchChange"
                      :search-loading="queryLoading"
                      @search="whenSearchClick"></table-filter>
        <div class="flex-grow-1 overflow-auto" style="min-height: 300px">
            <mini-table ref="_miniTable"
                        v-bind="$attrs"
                        read-only
                        :entity-name="$_configCode"
                        :items="rows"
                        :fields="visibleFields"
                        :loading="formLoading"
                        filterable
                        disable-first-index-column
                        :enable-row-check="!disableRowCheck"
                        enable-pagination
                        :total-count="totalCount"
                        :total-loading="countLoading"
                        @pageChange="whenPageChange"
                        sort-query
                        @sortChange="whenSortChange"
                        @rowChecked="whenRowChecked"
                        @linkClick="$emit('linkClick', $event)">
                <template #rightHeader>
                    <slot name="rightHeader"></slot>
                    <mini-button v-if="noQueryInput" :loading="queryLoading" @btnClick="whenSearchClick">
                        搜索
                    </mini-button>
                    <excel-import-btn v-if="enableImport" :service="service" :config-id="configId"
                                      :form-name="importFormName" :save-holder="importSaveHolder || newRowSaveHolder"
                                      @success="queryRows"/>
                    <excel-export-btn v-if="!disableExport" :service="service" :config-id="configId"
                                      :filter="mergedQueryForm"></excel-export-btn>
                </template>
                <template #headOfRow="{row}">
                    <slot name="headOfRow" :row="row"></slot>
                </template>
                <template #leftHeader>
                    <template v-if="enableEdit">
                        <mini-button v-if="disableEditBtn%2!==0" name="add" @btnClick="openEditForm(true)">
                            <i class="fa-solid fa-plus"></i>
                        </mini-button>
                        <mini-button v-if="disableEditBtn%3!==0" :disable="$_notCheckedOne" name="edit" @btnClick="openEditForm(false)">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </mini-button>
                        <delete-button v-if="disableEditBtn%5!==0" :loading="deleteLoading" :disable="$_notChecked" name="delete"
                                       variant="outline-primary"
                                       @btnClick="deleteRows"></delete-button>
                    </template>
                    <slot name="leftHeader"></slot>
                </template>
                <template v-for="name of slotNames" v-slot:[name]="{row}">
                    <slot :name="name" :row="row"></slot>
                </template>
            </mini-table>

            <re-b-modal ref="editForm" header="Edit" hide-footer>
                <formula-form v-if="enableEdit && editFormConfig.length>0"
                              :fields="editFormConfig"
                              :item="currentEditRow"
                              submit-label="保存"
                              :enable-submit-continuous="editNew"
                              submit-continuous-label="保存并继续"
                              :loading="saveLoading"
                              @submit="saveRow"
                              @submitContinuous="saveRow($event, true)"></formula-form>
                <div v-else>
                    未配置，请联系相关人员
                </div>
            </re-b-modal>
        </div>
    </div>

</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import TableSearch from "@/components/common/inputs/table-search/TableSearch.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import FormulaForm from "@/components/common/inputs/FormulaForm.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";
import queryViewEditMixin from "@/components/common/display/query-view/mixin/query-view-edit-mixin";
import excelOperateMixin from "@/components/common/display/query-view/mixin/excel-operate-mixin";
import ExcelImportBtn from "@/components/common/display/query-view/stuff/ExcelImportBtn.vue";
import ExcelExportBtn from "@/components/common/display/query-view/stuff/ExcelExportBtn.vue";
import TableFilter from "@/components/common/inputs/table-search/TableFilter.vue";

export default {
    name: "QueryView",
    mixins: [queryViewEditMixin, excelOperateMixin],
    components: {
        TableFilter,
        ExcelExportBtn,
        ExcelImportBtn,
        DeleteButton,
        FormulaForm,
        ReBModal,
        TableSearch,
        MiniButton,
        MiniTable
    },
    props: {
        configCode: String,
        useConfigId: [Number, String],
        filter: Object,
        noQueryInput: {
            type: Boolean,
            default: false
        },
        skipPathQuery: {
            type: Boolean,
            default: false
        },
        disableRowCheck: Boolean,
        fieldAddition: Object,
        defaultFilterForm: Object,
    },
    data() {
        return {
            baseConfigUri: process.env.VUE_APP_EM_ASSISTANT_URL + "/qg",
            i18nLoading: false,
            formLoading: false,
            queryLoading: false,
            originalFields: [],
            fields: [],
            rows: [],
            service: null,
            configId: null,
            currentPage: {
                pageNumber: 0,
                pageSize: 20,
            },
            countLoading: false,
            totalCount: 0,
            orders: [],

            queryForm: this.defaultFilterForm ? {...this.defaultFilterForm} : {},
            queryChange: false,

            slotNames: [],
            needInitQuery: false,
        }
    },
    computed: {
        $_configCode() {
            return this.configCode || 'qv-code-' + this.useConfigId;
        },
        needReTransCode() {
            if (this.$store.state.queryViewStore.reloadFlag) {
                //
            }
            let set = this.$store.state.queryViewStore.needUpdateCode;
            return set.has(this.$_configCode);
        },
        visibleFields() {
            let temp = [];
            for (let item of this.fields) {
                if (item.visible) {
                    if (this.fieldAddition && item.key in this.fieldAddition) {
                        this.copyObj2Obj(this.fieldAddition[item.key], item);
                    }
                    temp.push(item);
                }
            }
            return temp;
        },
        mergedQueryForm() {
            return this.getQueryForm();
        },
    },
    watch: {
        needReTransCode() {
            if (this.needReTransCode) {
                this.initPage();
                this.$store.commit('queryViewStore/finish', this.configCode);
            }
        },
    },
    mounted() {
        this.initPage();
        this.slotNames = this.$refs._miniTable.slotNames();
    },
    methods: {
        initPage() {
            let code = this.configCode;
            if (this.hasCode(code)) {
                this.$queryIdByCode(code).then(res => {
                    this.service = res.service;
                    this.configId = res.id;
                    if (this.configId) {
                        this.getFullForm();
                        this.queryRows();
                        this.countRows();
                    }
                });
            } else if (this.hasCode(this.useConfigId)) {
                this.configId = this.useConfigId;
                this.needInitQuery = true;
                this.getFullForm();
            } else {
                this.$message.warning("Error");
                return false;
            }
            return code;
        },
        getFullForm() {
            let key = 'query_view_form_' + this.configId;
            let localValue = localStorage[key];
            let lastTime = null;
            if (localValue) {
                let temp = JSON.parse(localValue);
                if (temp instanceof Array) {//兼容低版本
                    this.fields = temp;
                } else {
                    lastTime = temp.lastModifyTime;
                    this.readForm(temp);
                }
            } else {
                this.formLoading = true;
            }
            this.$store.dispatch('api/post', {
                url: `${this.baseConfigUri}/view/full`,
                data: {
                    id: this.configId,
                    lastModifyTime: lastTime
                }
            }).then(res => {
                if (res && res.data) {
                    this.readForm(res.data);
                    localStorage[key] = JSON.stringify(res.data);
                }
            }).finally(() => this.formLoading = false);
        },
        readForm(res) {
            let form = res.form;
            if (form) {
                this.fields = form;
            }
            this.editFormMap = res.editForms;
            let i18n = res.i18n;
            let kp = res.keyPrefix;
            if (i18n && kp) {
                for (let lang in i18n) {
                    let temp = {};
                    for (let k in i18n[lang]) {
                        temp[kp + k] = i18n[lang][k];
                    }
                    this.$i18n.add(lang, temp);
                }
            }
            if (this.needInitQuery) {
                this.service = res.service;
                this.queryRows();
                this.countRows();
            }
        },
        queryRows() {
            if (this.service) {
                this.queryLoading = true;
                let page = {
                    orders: this.orders,
                };
                this.copyObj2Obj(this.currentPage, page, true);
                this.$query({
                    service: this.service,
                    id: this.configId,
                    where: this.getQueryForm(),
                    page: page
                }).then(res => {
                    this.rows = res.data;
                    this.$nextTick(() => {
                        this.$store.commit('queryViewStore/setCurrentRows', {
                            code: this.$_configCode,
                            rows: this.rows
                        });
                        if (this.$refs._miniTable) {
                            this.$refs._miniTable.clearChecked();
                        }
                        this.whenRowChecked([]);
                    });
                }).finally(() => this.queryLoading = false);
            }
        },
        countRows() {
            if (this.service) {
                this.countLoading = true;
                this.$query({
                    service: this.service,
                    id: this.configId,
                    where: this.getQueryForm(),
                    count: true
                }).then(res => {
                    this.totalCount = res.data;
                }).finally(() => this.countLoading = false);
            }
        },
        whenPageChange(page) {
            this.currentPage = page;
            this.queryRows();
        },
        whenSortChange(sort) {
            this.orders = [sort];
            this.queryRows();
        },
        whenSearchClick(form) {
            this.whenSearchChange(form);
            this.$nextTick(() => {
                if (this.fields && this.fields.length > 0) {
                    this.queryRows();
                    if (this.queryChange) {
                        this.countRows();
                        this.queryChange = false;
                    }
                } else {
                    this.initPage();
                }
            });
        },
        getQueryForm() {
            let temp = this.deepCopyObj(this.queryForm);
            if (!this.skipPathQuery) {
                let routeQuery = this.$route.query;
                for (let key of Object.keys(routeQuery)) {
                    let index = key.lastIndexOf("Filter");
                    if (index >= 0 && key.length - index === 6) {//end with
                        temp[key.substring(0, index)] = routeQuery[key];
                    }
                }
            }
            if (this.filter) {
                for (let key of Object.keys(this.filter)) {
                    temp[key] = this.filter[key];
                }
            }
            return temp;
        },

        whenSearchChange(form) {
            this.queryForm = form;
            this.queryChange = true;
        },
        whenRowChecked(ids) {
            this.$store.commit('queryViewStore/setCheckedIds', {
                code: this.$_configCode,
                ids: ids
            });
            this.$emit('rowChecked', ids);
        }
    },
    beforeDestroy() {
        this.$store.dispatch('queryViewStore/clear', this.$_configCode);
    }
}
</script>

<style scoped>
/* =====================================================================
   QueryView —— 现代化样式 (drop-in)
   表格部分沿用 MiniTable 现代化样式；本文件负责 QueryView 特有的
   "查询条 / TableFilter" 部分。只改外观，不改结构与功能。
   主色 $primary #1E5274（取自 _mmf_variables.scss）。
   ===================================================================== */

/* 查询条卡片化：白底、发丝边框、圆角、轻投影、内边距 */
.qv-filter-panel {
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(20, 46, 74, .04), 0 6px 22px rgba(20, 46, 74, .06);
    padding: 14px 16px !important;
    margin-bottom: 14px !important;
    align-items: flex-end;          /* 让标签+输入框与右侧按钮底部对齐 */
}

/* 每个筛选项：留白更舒展 */
.qv-filter-panel >>> .filter-item {
    width: 188px !important;
    min-width: 188px;
    margin-right: 14px !important;
}
.qv-filter-panel >>> .filter-item label {
    font-size: 11.5px;
    font-weight: 600;
    color: #5b6b7a;
    letter-spacing: .02em;
    margin-bottom: 5px;
}

/* 输入框 / 下拉框 / 选择器：统一高度、圆角、柔和边框 + 聚焦高亮环 */
.qv-filter-panel >>> .form-control,
.qv-filter-panel >>> .custom-select,
.qv-filter-panel >>> .b-form-datepicker .form-control,
.qv-filter-panel >>> .mini-multi-select {
    height: 36px;
    border: 1px solid #dfe7ef;
    border-radius: 8px;
    color: #33495c;
    box-shadow: none;
    transition: border-color .12s ease, box-shadow .12s ease;
}
.qv-filter-panel >>> .form-control:focus,
.qv-filter-panel >>> .custom-select:focus {
    border-color: #1E5274;
    box-shadow: 0 0 0 3px rgba(30, 82, 116, .10);
}
.qv-filter-panel >>> .form-control::placeholder {
    color: #9fb0c0;
}

/* Element UI 日期/时间范围选择器（el-date-picker，size=mini 默认仅 28px）：
   与文本框 / 下拉框统一为 36px 高度及一致外观，修复框体高度不齐 */
.qv-filter-panel >>> .el-range-editor.el-input__inner,
.qv-filter-panel >>> .el-range-editor--mini.el-input__inner,
.qv-filter-panel >>> .el-date-editor .el-input__inner {
    height: 36px !important;
    border: 1px solid #dfe7ef;
    border-radius: 8px;
    box-shadow: none;
}
.qv-filter-panel >>> .el-range-editor.is-active,
.qv-filter-panel >>> .el-range-editor.is-active:hover,
.qv-filter-panel >>> .el-date-editor .el-input__inner:focus {
    border-color: #1E5274;
    box-shadow: 0 0 0 3px rgba(30, 82, 116, .10);
}
.qv-filter-panel >>> .el-range-editor .el-range-input {
    color: #33495c;
}
.qv-filter-panel >>> .el-range-editor .el-range-separator,
.qv-filter-panel >>> .el-range-editor .el-range__icon,
.qv-filter-panel >>> .el-range-editor .el-range__close-icon {
    color: #9fb0c0;
}

/* 右侧按钮组：展开 / 清空 用浅描边幽灵按钮，搜索用主色实心 */
.qv-filter-panel >>> .btn-outline-secondary {
    color: #5b6b7a;
    border-color: #e3e9f0;
    background: #fff;
    border-radius: 8px;
    height: 36px;
    padding: 0 14px;
    box-shadow: none;
}
.qv-filter-panel >>> .btn-outline-secondary:hover {
    background: #f4f8fc;
    color: #1E5274;
    border-color: #cfdbe7;
}
.qv-filter-panel >>> .search-btn,
.qv-filter-panel >>> .search-btn .btn,
.qv-filter-panel >>> .btn-primary {
    height: 36px;
    border-radius: 8px;
    font-weight: 700;
    background: #1E5274;
    border-color: #1E5274;
    box-shadow: 0 1px 2px rgba(30, 82, 116, .25);
}
.qv-filter-panel >>> .search-btn .btn:hover,
.qv-filter-panel >>> .btn-primary:hover {
    background: #16415d;
    border-color: #16415d;
}
</style>
